export default {"src":"/_next/static/media/type_format.dc5589b4.svg","height":539,"width":744};